'use client'

import { Button } from '@dd3tech/wiggui/Button'
import { Flex } from '@dd3tech/wiggui/Flex'
import { Modal } from '@dd3tech/wiggui/Modal'
import { Text } from '@dd3tech/wiggui/Text'
import { composeClasses } from '../../../../../utils/src/strings'
import { CompleteProfileSvg } from '../../../../svg/CompleteProfileSvg'
import { useCompleteProfile } from './hooks'
import { InputCompleteProfile } from './components'

export const ModalCompleteProfile = () => {
  const {
    isOpen,
    setStep,
    step,
    titleByStep,
    formInputs,
    buttonSavedIsDisabled,
    handleOnSubmit,
    isLoading,
    setIsOpen
  } = useCompleteProfile()

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen({ isOpen: false })}
      enableBgBlur
      className={composeClasses('max-w-[524px] w-full')}
    >
      <Modal.Header
        title={titleByStep}
        isShowDivider
        isShowCloseButton={false}
      />
      <Modal.Body className="max-h-[70vh] w-full overflow-y-auto ui-kit-scrollbar">
        {step === 1 && (
          <Flex dir="col" items="center" justify="center" gap="gap-6" wFull>
            <CompleteProfileSvg />
            <Text className="text-body-m text-primary">
              Completa la información de tu perfil para continuar
            </Text>
          </Flex>
        )}
        {step === 2 && (
          <Flex dir="col" gap="gap-6" items="center" justify="center" wFull>
            {formInputs?.map((input) => {
              return (
                <Flex
                  key={input?.name}
                  dir="col"
                  gap="gap-6"
                  items="start"
                  justify="start"
                  wFull
                >
                  <Text className="text-primary text-body-bold-l">
                    Datos de contacto
                  </Text>
                  <Flex
                    dir="row"
                    className="flex-wrap"
                    wFull
                    items="center"
                    justify="start"
                    gap="gap-6"
                  >
                    <InputCompleteProfile input={input} key={input.name} />
                  </Flex>
                </Flex>
              )
            })}
          </Flex>
        )}
      </Modal.Body>
      <Modal.Footer
        className={composeClasses(
          step === 1 ? 'items-center justify-center' : 'items-end justify-end',
          'flex-row flex py-3 border-t gap-3 border-surface-strokes w-full px-6'
        )}
      >
        {step === 1 && (
          <Button
            fullWidth
            variant="secondary"
            onClick={(event) => {
              event.stopPropagation()
              setStep(2)
            }}
          >
            Completar datos
          </Button>
        )}
        {step === 2 && (
          <Button
            isDisabled={buttonSavedIsDisabled}
            isLoading={isLoading}
            onClick={(event) => {
              event.stopPropagation()
              handleOnSubmit()
            }}
            variant="primary"
          >
            Guardar información
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
